export const PROFILE_KEY = "profile";

export const BASE_ITEMS = [
  {
    key: PROFILE_KEY,
    caption: "Profile",
    required: true,
    children: [
      { key: "addresses", caption: "Addresses" },
      { key: "settings", caption: "Person Settings" }
    ]
  },
  {
    key: "representations",
    caption: "Representation",
    children: [
      { key: "client", caption: "Client Profile", flag: 4 },
      { key: "lead", caption: "Lead Profile", flag: 2 },
      { key: "staff", caption: "Staff Profile", flag: 8 },
      { key: "attorney", caption: "Attorney Profile", flag: 16 },
      { key: "judge", caption: "Judge Profile", flag: 1 },
      { key: "vendor", caption: "Vendor Profile", flag: 32 }
    ]
  },
  {
    key: "matters",
    caption: "Matters",
    children: [
      { key: "caseParties", caption: "Party Links" },
      { key: "caseStaff", caption: "Staff Assignments" },
      { key: "matterProfiles", caption: "Matter Profiles" }
    ]
  },
  {
    key: "activity",
    caption: "Activity",
    children: [
      { key: "calendar", caption: "Calendar" },
      { key: "time", caption: "Time" },
      { key: "expenses", caption: "Expenses" },
      { key: "invoices", caption: "Invoices" },
      { key: "payments", caption: "Payments" },
      { key: "trust", caption: "Trust" },
      { key: "logs", caption: "Notes and Logs" },
      { key: "board", caption: "Board Tasks" },
      { key: "surveys", caption: "Surveys" }
    ]
  },
  {
    key: "files",
    caption: "Files"
  }
];

export function flatten(items) {
  return items.reduce((memo, item) => {
    memo.push(item);
    if (item.children) memo.push(...flatten(item.children));
    return memo;
  }, []);
}

export function descendantKeys(item) {
  return item.children ? flatten(item.children).map((child) => child.key) : [];
}

export function visibleItems(items, flags) {
  return items
    .map((item) => {
      if (item.flag && (flags & item.flag) === 0) return null;
      const children = item.children ? visibleItems(item.children, flags) : null;
      if (item.children && !children.length) return null;
      return { ...item, children };
    })
    .filter(Boolean);
}

export function defaultSelection(items) {
  return flatten(items).reduce((memo, item) => {
    memo[item.key] = true;
    return memo;
  }, {});
}
